import { AfterViewChecked, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss'],
  standalone: false,
})
export class DynamicTableComponent implements OnChanges, AfterViewChecked {
  public constructor() {}

  @Input() public props: app.models.DynamicPropsDictionary;

  public hasErrors: boolean = false;
  public errorMessage: string;

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.props == null) {
      this.logError('Props are not defined');
    }

    if (changes.props.currentValue == null && changes.props.firstChange) {
      return;
    }

    this.clearErrors();
  }

  ngAfterViewChecked() {
    this.removeFromDOMNotRenderedColumns();
  }

  private removeFromDOMNotRenderedColumns() {
    if (this.props) {
      Object.keys(this.props).forEach(key => {
        document.querySelectorAll(`[id=${key}]`).forEach(element => {
          if (!this.props[key].rendered) {
            element.remove();
          }
        });
      });
    }
  }

  private logError(message: string) {
    this.hasErrors = true;
    this.errorMessage = `[DEBUG] ${message}`;
  }

  private clearErrors() {
    this.hasErrors = false;
    this.errorMessage = null;
  }
}
